import React from "react";
import { Form, Select } from "antd";
import { GENDER_OPTIONS, SIZE_OPTIONS } from "../constants";

// Campos extra que solo aplican a la categoría "Ropa"
export default function ClothingFields() {
  return (
    <>
      <Form.Item
        name="gender"
        label="¿Para quién?"
        rules={[{ required: true, message: "Selecciona para quién es la ropa" }]}
      >
        <Select placeholder="Selecciona una opción" options={GENDER_OPTIONS} />
      </Form.Item>

      <Form.Item
        name="sizes"
        label="Tallas disponibles"
        rules={[{ required: true, message: "Selecciona al menos una talla" }]}
      >
        <Select
          mode="multiple"
          placeholder="Selecciona las tallas"
          options={SIZE_OPTIONS}
        />
      </Form.Item>

      <Form.Item
        name="colors"
        label="Colores disponibles"
        rules={[{ required: true, message: "Selecciona al menos un color" }]}
      >
        <Select
          mode="tags"
          placeholder="Escribe los colores disponibles"
          tokenSeparators={[","]}
        />
      </Form.Item>
    </>
  );
}
